import { MutationTree } from 'vuex';
import { OPEN_ADDFUNDS, CLOSE_ADDFUNDS } from './constants';
import { AddFundsState } from './types';

const mutations = {
    [OPEN_ADDFUNDS](state: AddFundsState) {
        state.open = true;
    },
    [CLOSE_ADDFUNDS](state: AddFundsState) {
        state.open = false;
    },
} as MutationTree<AddFundsState>;

export default mutations;
